import ApiClient from './ApiClient';

class CustomSlaAPI extends ApiClient {
  constructor() {
    super('custom_sla_policies', { accountScoped: true });
  }
}

export default new CustomSlaAPI();
